import styled from "styled-components";

export const ServicesContainer = styled.div`
  height: 800px;
  display: flex;
  background: #010606;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  @media screen and (max-width: 768px) {
    height: 1100px;
  }

  @media screen and (max-width: 480px) {
    height: 1300px;
  }
`;

export const ServicesWrapper = styled.div`
  display: grid;
  margin: 0 auto;
  grid-gap: 16px;
  padding: 0 50px;
  max-width: 1000px;
  align-items: center;
  grid-template-columns: 1fr 1fr 1fr;

  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 768px) {
    padding: 0 20px;
    grid-template-columns: 1fr;
  }
`;

export const ServicesCard = styled.div`
  padding: 30px;
  display: flex;
  background: #fff;
  max-height: 340px;
  align-items: center;
  border-radius: 10px;
  flex-direction: column;
  justify-content: flex-start;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
`;

export const ServicesIcon = styled.img`
  width: 160px;
  height: 160px;
  margin-bottom: 10px;
`;

export const ServicesH1 = styled.h1`
  color: #fff;
  font-size: 2.5rem;
  margin-bottom: 64px;

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

export const ServicesH2 = styled.h2`
  font-size: 1rem;
  margin-bottom: 10px;
`;

export const ServicesP = styled.p`
  font-size: 1rem;
  text-align: center;
`;
